"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.5827 21.6043-1.3979 1.3967-2.7573-2.7557a3.3285 3.3285 0 0 1-.1735.0045c-1.446 0-2.6714-.9444-3.0932-2.25h-3.9043c-.4218 1.3056-1.6473 2.25-3.0933 2.25-1.446 0-2.6715-.9444-3.0932-2.25H1v-14h.1721l-.8377-.8372L1.7493 1.749l19.8334 19.8553zm-8.4033-5.6045-10.006-10h-.1733v10H4.07c.4217-1.3056 1.6472-2.25 3.0932-2.25s2.6715.9444 3.0933 2.25h2.9229zm-6.0162-.25c-.6903 0-1.25.5597-1.25 1.25 0 .6904.5597 1.25 1.25 1.25.6904 0 1.25-.5596 1.25-1.25 0-.6903-.5596-1.25-1.25-1.25z"
  }), _react.default.createElement("path", {
    d: "m6.8245 3.9998 1.9978 2H14v5.1836l2 2.0022V8.9998h1.9833l3.0207 4.3152v2.6848h-.6568c-.4218-1.3056-1.6472-2.25-3.0933-2.25-.2153 0-.4258.021-.6294.0609l4.1844 4.1891h2.1951v-5.3152l-3.9794-5.6848H16v-3H6.8245z"
  })];
};

exports.default = _default;